module.exports = "<p>[# summary]</p>\n<h3 id=\"资产-symbol\">资产 {symbol}</h3>\n<p>{description}<br>发行人 {issuer}</p>\n<p>欧元 (标识: €; 符号: EUR) 是欧元区参与国的官方货币。</p>\n";